// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"draftProperty_onMlsAt":{"b":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function mlsListingTypeV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "OFF_MLS" || $$enum === "COMING_SOON") {
    return $$enum;
  }
}

let mlsListingTypeV5_fromString = mlsListingTypeV5_decode;

let Utils = {
  mlsListingTypeV5_decode: mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: mlsListingTypeV5_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LocalDraftProperty",
          "kind": "LinkedField",
          "name": "draftProperty",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mlsListingType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "onMlsAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeZone",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraft",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
